import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getIsUserAnAdmin } from '../UserData/userDataEntity';
import Users from './Users/Users';
import { getIsLoading as getIsUserLoading } from '../Self/selfEntity';
import './PaymentRouting.scss';

export class PaymentRouting extends Component {
    static propTypes = {
        isAdmin: PropTypes.bool,
        isUserLoading: PropTypes.bool
    };

    render() {
        if (!this.props.isAdmin && !this.props.isUserLoading) {
            return (<div className="emvio-user-route-management">
                Insufficient access rights to manage users.
            </div>);
        }

        return (<div className="emvio-user-route-management">
            <Users />
        </div>);
    }
}

function mapStateToProps(state) {
    return {
        isAdmin: getIsUserAnAdmin(state),
        isUserLoading: getIsUserLoading(state)
    };
}

export default connect(mapStateToProps)(PaymentRouting);
